const navbarText = [
  {
    home: "Home",
    about: "About Us",
    services: "Services",
    routes: "Routes",
    contact: "Contact",
  },
  {
    home: "Pradžia",
    about: "Apie mus",
    services: "Paslaugos",
    routes: "Kryptys",
    contact: "Kontaktai",
  },
  {
    home: "Start",
    about: "O nas",
    services: "Usługi",
    routes: "Kierunki",
    contact: "Kontakty",
  },
];

export default navbarText;
